// @ts-check
/**
 * @param {Element} element
 */
const handleGlossaryElement = (element) => {
  /** @type {HTMLButtonElement | null} */
  const glossaryToggle = element.querySelector("button.glossary-toggle");
  /** @type {HTMLButtonElement | null} */
  const glossaryClose = element.querySelector("button.glossary-close");
  /** @type {HTMLDivElement | null} */
  const glossaryContainer = element.querySelector("div.glossary-container");

  if (!glossaryToggle || !glossaryClose || !glossaryContainer) {
    console.warn("Glossary element structure is not as expected.");
    return;
  }

  /** @type {HTMLDivElement | null} */
  const glossaryArrowRight = glossaryToggle.querySelector(
    ".glossary-arrow-right"
  );
  /** @type {HTMLDivElement | null} */
  const glossaryArrowLeft = glossaryToggle.querySelector(
    ".glossary-arrow-left"
  );

  if (!glossaryArrowRight || !glossaryArrowLeft) {
    console.warn("Glossary toggle structure is not as expected.");
    return;
  }

  let isOpen = glossaryContainer.dataset.open === "true";

  glossaryContainer.children[0].setAttribute(
    "style",
    `padding-bottom: ${glossaryToggle.offsetHeight + 32}px;`
  );

  /**
   * @param {boolean} open
   */
  const toggleGlossary = (open) => {
    glossaryContainer.dataset.open = "" + open;
    glossaryToggle.setAttribute("data-open", "" + open);
    glossaryArrowLeft.classList.toggle("hidden", !open);
    glossaryArrowRight.classList.toggle("hidden", open);
  };

  /**
   * @returns {boolean}
   */
  const openGlossary = () => {
    glossaryContainer.classList.replace("hidden", "grid");
    toggleGlossary(true);
    return true;
  };

  /**
   * @returns {boolean}
   */
  const closeGlossary = () => {
    glossaryContainer.classList.replace("grid", "hidden");
    toggleGlossary(false);
    return false;
  };

  glossaryToggle.addEventListener("click", () => {
    if (isOpen) {
      isOpen = closeGlossary();
    } else {
      isOpen = openGlossary();
    }
  });

  glossaryClose.addEventListener("click", () => {
    isOpen = closeGlossary();
  });

  document.addEventListener("keyup", (event) => {
    if (event.key === "Escape" && isOpen) {
      isOpen = closeGlossary();
    }
  });
};

document.addEventListener("DOMContentLoaded", () => {
  const glossaryElements = document.querySelectorAll(".glossary-element-block");
  if (glossaryElements.length > 0) {
    glossaryElements.forEach((element) => handleGlossaryElement(element));
  }
});
